

























import { Component, Vue } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import * as shareApi from '../api/shareApi'
import { appGolbal } from '@ivy/fts/appGlobal'
import resultModal from '../comps/resultModal.vue'
import authModal from '../comps/authModal.vue'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import Notice from './notice.vue'

@Component({
  components: {
    Notice,
  },
})
export default class extends Vue {
  ios10Shadow: boolean = false
  hasTest: boolean = false
  goodsUrl: string = ''
  goodsImg: string = ''
  hasAccess: boolean = false
  onlyReport: boolean = false
  info: any = {}
  rangeDay: number = 30
  tipText: string = ''
  async ios10ShadowClick() {
    window.location.reload()
  }
  async created() {
    await this.onReady()
    await env.init()
    await this.initialize()
    // 蓝思测评访问埋点
    let { from, position } = this.$route.query
    if (from) {
      await shareApi.getUpload('Display_Lexile', from, position)
    } else {
      await shareApi.getUpload('Display_Lexile', 'h5')
    }
    env.type === 'wx' && (await shareApi.share())
  }
  // 监听微信自带返回按钮
  async onReady() {
    window.history.pushState({ url: '#' }, '监听用户返回操作', '#')
    window.onpopstate = () => this.pushHistory()
  }
  // 修改拦截的返回事件
  pushHistory() {
    window.history.pushState({ url: '#' }, '监听用户返回操作', '#')
    return
  }
  toReport() {
    window.location.href = `${
      window.location.origin
    }/act2/reimsAssess/report?_hideShareButton=1`
  }
  async initialize() {
    if (await env.getIsLogin()) {
      let { data = {} } = await shareApi.requireGet(
        '/api/m-course/lexile/testResult'
      )
      this.tipText = data.text || '您没有蓝思测评权限，无法进入测评'
      this.hasTest = data.current ? true : false
      this.onlyReport = data.last_time ? true : false
      this.rangeDay = data.interval_days
      this.hasAccess = data.has_access
      this.goodsUrl = data.goods_url
      this.goodsImg = data.goods_img
      if (!this.hasAccess) {
        this.$Toast(this.tipText)
      }
      // 后台选择跳转地址会存在undefined参数而报错，做下处理
      if (this.goodsUrl.includes('undefined')) {
        this.goodsUrl = ''
      }
      if (!this.hasAccess && !this.hasTest && this.goodsUrl && this.goodsImg) {
        return showDiv(authModal, {
          goodsUrl: this.goodsUrl,
          goodsImg: this.goodsImg,
        })
      }
    }
  }
  async toTest() {
    if (!(await env.getIsLogin())) {
      this.ios10Shadow = true
      return await env.login()
    } else {
      if (!this.hasAccess && !this.hasTest) {
        if (this.goodsUrl && this.goodsImg) {
          return showDiv(authModal, {
            goodsUrl: this.goodsUrl,
            goodsImg: this.goodsImg,
          })
        } else {
          return this.$Toast(this.tipText)
        }
      }
      await this.toBabyMessage()
    }
  }
  async toBabyMessage() {
    // [开始测评]的点击埋点
    await shareApi.getUpload('Click_PlacementTest_Lexile')
    window.location.href = `${
      window.location.origin
    }/act2/reimsAssess/babyMessage?_hideShareButton=1`
  }
  async again() {
    if (this.rangeDay && this.rangeDay > 180) {
      // 【再测一次】的点击埋点
      await shareApi.getUpload('Click_ProgressMonitoringTest_Lexile')
      window.location.href = `${
        window.location.origin
      }/act2/reimsAssess/needKnow?_hideShareButton=1`
    } else {
      showDiv(resultModal, { rangeDay: this.rangeDay })
    }
  }
}
